var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-relative"},[_vm._t("default"),_c('qd-loading',{attrs:{"active":_vm.active,"is-full-page":_vm.isFullPage,"can-cancel":_vm.canCancel,"on-cancel":_vm.onCancel,"animation":_vm.animation}},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }